// extracted by mini-css-extract-plugin
export default {"wrapper":"formInputs_wrapper__VSgIl"};